<div class="badge-container" [ngClass]="'size-' + size">
  <p class="p-medium">{{ notification > maxValue ? maxValue : notification }}</p>
  <p class="p-medium" *ngIf="notification > maxValue">+</p>
</div>
